import React, { Fragment } from "react";
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/themes/theme-red.css";
import { Hamburger } from "./svg/Hamburger";
import { Pen } from "./svg/Pen";
import { PaperStack } from "./svg/PaperStack";
import { Helmet } from "react-helmet";
import Slider from "./Slider/Slider";

const SliderData = [
  {
    source: "/img/slide1.jpg",
  },
  {
    source: "/img/slide2.jpg",
  },
];

export const LandingPage = ({ setShowModal }) => {
  return (
    <Fragment>
      <Helmet>
        <title>Jamb Easy Landing Page</title>
        <meta
          name="description"
          content="A preview to a wonderful experience"
        />
        <meta name="theme-color" content="#008f68" />
        <meta property="og:title" content="JambEasy Landing page" />
        <meta
          property="og:description"
          content="A preview to a wonderful experience"
        />
        <meta
          property="og:image"
          content="https://i.ibb.co/t88Lfx7/jamblogo3.png"
        />
      </Helmet>
      <div className="container-fixed"></div>
      <div className="container-fixed2">
        <PaperStack />
        <Pen />
      </div>
      <div style={{ background: "transparent" }}>
        <div className="header">
          <span className="svg-box">
            <Hamburger />
          </span>
        </div>
        <div className="content">
          <div className="jumbo-div-header">
            JambEasy is a prolific tool designed to help you succeed in JAMB
          </div>
          <div className="jumbo-div-text">
            JambEasy is coming soon. Subscribe here to get notified when the
            website and app are completed
          </div>
          <div className="button-div">
            <AwesomeButton
              type="primary"
              ripple
              className="button"
              onPress={() => {
                setShowModal(true);
              }}
            >
              Register
            </AwesomeButton>
          </div>
          <div className="follow-div">
            <span className="span">follow us:</span>
            <span className="socials" style={{ zIndex: 100 }}>
              <a
                href="https://web.facebook.com/jambeazy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512.002 512.002"
                >
                  <circle
                    style={{ fill: " none" }}
                    stroke="#fff"
                    strokeWidth="10px"
                    cx="256.001"
                    cy="256"
                    r="256"
                  />
                  <path
                    style={{ fill: "none" }}
                    d="M511.596,241.7L391.019,121.085c-1.998,0.605-6.982-1.714-9.173-1.274
	c-51.717,8.62-101.71,0-151.704,13.791c-24.135,6.896-25.859,36.202-34.478,55.165c-12.067,34.478-10.343,72.404-25.859,105.158
	c-10.343,22.411-34.478,36.202-43.098,62.061c-2.875,10.785-2.705,24.379-5.956,34.69l120.98,120.922
	c4.725,0.26,9.48,0.403,14.269,0.403c141.384,0,256-114.616,256-256C512.001,251.201,511.858,246.434,511.596,241.7z"
                  />
                  <g>
                    <path
                      style={{ fill: " #ffffff" }}
                      d="M363.043,109.466H148.958c-21.809,0-39.49,17.68-39.49,39.49v214.085
		c0,21.811,17.68,39.49,39.49,39.49h105.584l0.183-104.722h-27.21c-3.536,0-6.406-2.86-6.418-6.396l-0.133-33.759
		c-0.014-3.553,2.867-6.444,6.42-6.444h27.162v-32.618c0-37.852,23.118-58.463,56.884-58.463h27.71c3.543,0,6.42,2.874,6.42,6.42
		v28.463c0,3.546-2.874,6.42-6.416,6.42l-17.006,0.01c-18.363,0-21.921,8.725-21.921,21.533v28.239h40.351
		c3.848,0,6.83,3.358,6.375,7.173l-4.001,33.759c-0.381,3.232-3.122,5.665-6.375,5.665h-36.168l-0.183,104.726h62.826
		c21.809,0,39.49-17.682,39.49-39.491v-214.09C402.533,127.147,384.852,109.466,363.043,109.466L363.043,109.466z"
                    />
                    <polygon
                      style={{ fill: " #ffffff" }}
                      points="254.542,402.53 254.725,297.808 254.277,297.808 254.277,402.53 	"
                    />
                  </g>
                  <path
                    style={{ fill: " #d1d1d1" }}
                    d="M363.043,109.466H254.277v141.741h0.269V218.59c0-37.852,23.118-58.463,56.884-58.463h27.71
	c3.543,0,6.42,2.874,6.42,6.42v28.463c0,3.546-2.874,6.42-6.416,6.42l-17.006,0.01c-18.363,0-21.921,8.725-21.921,21.533v28.238
	h40.351c3.848,0,6.83,3.358,6.375,7.173l-4.001,33.759c-0.381,3.232-3.122,5.665-6.375,5.665h-36.168l-0.183,104.726h62.826
	c21.809,0,39.49-17.682,39.49-39.491V148.956C402.533,127.147,384.852,109.466,363.043,109.466z"
                  />
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </a>
              <a
                href="https://twitter.com/EasyJamb"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                >
                  <circle
                    style={{ fill: " none" }}
                    stroke="#fff"
                    strokeWidth="10px"
                    cx="256"
                    cy="256"
                    r="256"
                  />
                  <path
                    style={{ fill: " none" }}
                    d="M393.014,139.326c-26.703,23.169-53.253,43.475-74.954,71.852
	c-53.381,64.372-118.613,155.7-207.386,142.086l158.61,158.396c134.456-6.873,241.497-117.493,242.686-253.376L393.014,139.326z"
                  />
                  <path
                    style={{ fill: " #ffffff" }}
                    d="M397.872,162.471c-6.513,2.889-13.271,5.167-20.208,6.815c7.644-7.261,13.39-16.346,16.631-26.484
	c0.926-2.893-2.219-5.398-4.832-3.848c-9.65,5.725-20.044,10.016-30.894,12.762c-0.628,0.16-1.276,0.24-1.929,0.24
	c-1.979,0-3.896-0.733-5.411-2.065c-11.542-10.174-26.39-15.777-41.805-15.777c-6.672,0-13.405,1.04-20.016,3.091
	c-20.487,6.353-36.295,23.254-41.257,44.103c-1.86,7.818-2.362,15.648-1.496,23.264c0.097,0.876-0.314,1.486-0.569,1.772
	c-0.45,0.502-1.084,0.791-1.745,0.791c-0.072,0-0.15-0.003-0.224-0.01c-44.846-4.168-85.287-25.772-113.869-60.837
	c-1.455-1.789-4.253-1.569-5.415,0.422c-5.596,9.606-8.554,20.589-8.554,31.766c0,17.127,6.884,33.27,18.837,45.039
	c-5.027-1.193-9.893-3.07-14.414-5.582c-2.188-1.214-4.877,0.35-4.908,2.851c-0.31,25.445,14.588,48.087,36.905,58.282
	c-0.45,0.01-0.9,0.014-1.35,0.014c-3.537,0-7.121-0.338-10.645-1.015c-2.463-0.467-4.532,1.867-3.768,4.253
	c7.246,22.618,26.717,39.288,50.021,43.07c-19.339,12.983-41.863,19.83-65.302,19.83l-7.306-0.003c-2.255,0-4.16,1.469-4.73,3.65
	c-0.565,2.145,0.474,4.413,2.396,5.53c26.412,15.372,56.541,23.495,87.138,23.495c26.784,0,51.838-5.313,74.466-15.798
	c20.745-9.609,39.076-23.345,54.486-40.827c14.357-16.286,25.581-35.085,33.365-55.879c7.418-19.816,11.34-40.967,11.34-61.154
	v-0.964c0-3.241,1.465-6.291,4.024-8.37c9.706-7.882,18.16-17.158,25.122-27.572C403.796,164.578,400.896,161.13,397.872,162.471
	L397.872,162.471z"
                  />
                  <path
                    style={{ fill: " #d1d1d1" }}
                    d="M397.872,162.471c-6.515,2.889-13.271,5.167-20.208,6.815c7.644-7.261,13.39-16.346,16.632-26.484
	c0.926-2.893-2.219-5.398-4.832-3.848c-9.65,5.725-20.044,10.016-30.894,12.762c-0.628,0.16-1.276,0.24-1.929,0.24
	c-1.979,0-3.896-0.733-5.411-2.065c-11.542-10.174-26.39-15.777-41.805-15.777c-6.671,0-13.405,1.04-20.016,3.091
	c-14.322,4.441-26.343,14.048-33.985,26.546v205.477c6.222-2.029,12.293-4.403,18.198-7.139
	c20.745-9.609,39.076-23.345,54.486-40.827c14.357-16.287,25.581-35.085,33.365-55.879c7.418-19.816,11.34-40.967,11.34-61.154
	v-0.964c0-3.241,1.465-6.291,4.024-8.37c9.706-7.882,18.16-17.158,25.122-27.572C403.796,164.578,400.896,161.13,397.872,162.471z"
                  />
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </a>
              <a
                href="https://linkedin.com/in/zanzebra"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512.002 512.002"
                >
                  <circle
                    style={{ fill: " none" }}
                    stroke="#fff"
                    strokeWidth="10px"
                    cx="256.001"
                    cy="256"
                    r="256"
                  />
                  <path
                    style={{ fill: " none" }}
                    d="M511.016,233.634L394.729,117.198c-71.035,9.237-145.27,7.859-216.305,9.511
	c-29.306,0-58.613,13.791-53.441,46.545c10.343,65.508,15.515,129.293,3.448,196.525c-1.9,8.545-5.897,17.089-11.117,25.059
	L233.48,511.005c7.421,0.646,14.929,0.996,22.519,0.996c141.384,0,256-114.616,256-256
	C512.001,248.461,511.656,241.005,511.016,233.634z"
                  />
                  <path
                    style={{ fill: " #ffffff" }}
                    d="M376.023,109.468H135.979c-14.643,0-26.51,11.867-26.51,26.51V376.02
	c0,14.639,11.867,26.51,26.51,26.51h240.042c14.639,0,26.51-11.871,26.51-26.51V135.978
	C402.533,121.335,390.662,109.468,376.023,109.468L376.023,109.468z M200.155,362.517c0,4.263-3.453,7.716-7.716,7.716h-32.837
	c-4.263,0-7.716-3.455-7.716-7.716V224.856c0-4.263,3.455-7.716,7.716-7.716h32.839c4.263,0,7.716,3.455,7.716,7.716v137.661
	H200.155z M176.02,204.162c-17.23,0-31.196-13.969-31.196-31.201c0-17.229,13.965-31.196,31.196-31.196
	c17.232,0,31.198,13.969,31.198,31.196C207.218,190.195,193.251,204.162,176.02,204.162L176.02,204.162z M371.773,363.139
	c0,3.918-3.175,7.096-7.09,7.096h-35.242c-3.915,0-7.092-3.177-7.092-7.096v-64.574c0-9.63,2.826-42.21-25.172-42.21
	c-21.719,0-26.124,22.3-27.008,32.304v74.478c0,3.918-3.175,7.096-7.094,7.096h-34.082c-3.918,0-7.096-3.177-7.096-7.096V224.234
	c0-3.918,3.177-7.096,7.096-7.096h34.082c3.918,0,7.094,3.177,7.094,7.096v12.009c8.054-12.085,20.023-21.416,45.502-21.416
	c56.425,0,56.105,52.717,56.105,81.686v66.627H371.773z"
                  />
                  <path
                    style={{ fill: "#d1d1d1" }}
                    d="M376.023,109.468H255.427v107.67h7.647c3.918,0,7.094,3.177,7.094,7.096v12.009
	c8.054-12.085,20.023-21.416,45.503-21.416c56.425,0,56.105,52.717,56.105,81.686v66.625c0,3.918-3.175,7.096-7.09,7.096h-35.242
	c-3.915,0-7.092-3.177-7.092-7.096v-64.574c0-9.63,2.826-42.21-25.172-42.21c-21.719,0-26.124,22.3-27.008,32.304v74.478
	c0,3.918-3.175,7.096-7.094,7.096h-7.647v32.301h120.596c14.639,0,26.51-11.871,26.51-26.51V135.978
	C402.533,121.335,390.662,109.468,376.023,109.468z"
                  />
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </a>
            </span>
          </div>
        </div>
        <Slider slides={SliderData} />
      </div>
    </Fragment>
  );
};
